import Vue from 'vue'
import App from './App.vue'
import './plugins/analytics'
import vuetify from './plugins/vuetify'
import './plugins/axios'
import PageContent from './components/PageContent'
import './sass/main.scss'
import router from './router/router.js'

Vue.config.productionTip = false

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.component('page-content', PageContent)

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
